import React, { useEffect } from 'react';
import DealInfo from 'components/DealInfo';
import { report } from 'store/report';

const Agreement: React.FC = () => {
  useEffect(() => {
    report({ event: 'agency_manage', payload: '合作协议' });
  }, []);

  return (
    <div className="page-form-group">
      <div className="form-group-header">
        <h4>平台合作协议</h4>
      </div>
      <div className="agreement">
        <DealInfo />
      </div>
    </div>
  );
};

export default Agreement;
